import apiService from '../../services/api'

export default {
	namespaced: true,
	state: {
		providers: false,
	},
	getters: {
		providers: state => {
			return state.providers;
		},
		providerBySlug: state => slug => {
			if(!state.providers) return false;

			return state.providers.find(p => {
				return slug === p.vendor_slug;
			})
		},
		providersById: state => ids => {
			if(!state.providers) return [];

			return state.providers.filter(p => {
				return ids.indexOf(p.id) >= 0;
			})
		}
	},
	mutations: {
		updateProviders(state, providers) {
			state.providers = providers;
		},
	},
	actions: {


	}
}
